export default "__VITE_ASSET__CyQzsZBa__"